import { useTranslation } from 'react-i18next';

import type { OnboardingStep } from '@/features/onboarding/data';
import { cn } from '@/lib/utils';

type OnboardingStepperProps = {
    currentStep: OnboardingStep;
};

export function OnboardingStepper({ currentStep }: OnboardingStepperProps) {
    const { t } = useTranslation();
    const progress = currentStep === 1 ? 50 : 100;

    return (
        <div className='space-y-3'>
            <div className='flex items-center justify-between gap-4 font-mono text-xs uppercase tracking-[0.2em]'>
                <span className={cn(currentStep === 1 ? 'text-foreground' : 'text-muted-foreground')}>
                    {t('onboardingFlow.steps.personalizeLabel')}
                </span>
                <span className={cn(currentStep === 2 ? 'text-foreground' : 'text-muted-foreground')}>
                    {t('onboardingFlow.steps.connectLabel')}
                </span>
            </div>
            <div className='h-1 rounded-full bg-border'>
                <div
                    className='h-full rounded-full bg-primary transition-all duration-300'
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
}
